module.exports = __webpack_public_path__ + "img/watatsuki no toyohime.f4880ce3.png";